export default __webpack_public_path__ + "static/media/bg_hero_1.7bcda4ed.svg";